import {
    FETCH_ADMIN_COIN_VALUE_EDIT_REQUEST,
    FETCH_ADMIN_COIN_VALUE_EDIT_SUCCESS,
    FETCH_ADMIN_COIN_VALUE_EDIT_FAILURE,
  } from "./actionTypes";
  
  import { AdminCoinValueEditActions, AdminCoinValueEditState } from "./types";
  
  const initialState: AdminCoinValueEditState = {
    loading: false,
    result: null,
    error: null,
  };
  
  export default (state = initialState, action: AdminCoinValueEditActions) => {
    switch (action.type) {
      case FETCH_ADMIN_COIN_VALUE_EDIT_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FETCH_ADMIN_COIN_VALUE_EDIT_SUCCESS:
        return {
          ...state,
          loading: false,
          result: action.payload.result,
          error: null,
        };
      case FETCH_ADMIN_COIN_VALUE_EDIT_FAILURE:
        return {
          ...state,
          loading: false,
          result: [],
          error: action.payload.error,
        };
      default:
        return {
          ...state,
        };
    }
  };